import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const adsImporterSelectors = importerSelectors(
  'ads.importer',
);

export default adsImporterSelectors;
